module.exports = __webpack_public_path__ + "media/images/flags/KN-83b4cea5f7142473098a2434d054552b.svg";